import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "react-i18next";
import React from "react";
import dynamic from "next/dynamic";
const HRPage = dynamic(() => import("@/app/hr"), {
  ssr: false,
});

const HR = () => {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title>{t("HR_TAB_TITLE")}</title>
        <meta name="description" content={t("META_DESCRIPTION")} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="inter nation english school careers,inter nation hr, inter nation careers,english school jobs,english school careers,english school careers,esl teacher jobs,hr inter nation,education vacancies uzbekistan,inter nation vacancies "
        />
        <meta
          property="og:title"
          content="Inter Nation English School Careers"
        />
        <meta
          property="og:description"
          content="Inter Nation English School is hiring! Discover open positions and start your career with us."
        />
        <meta
          property="og:image"
          content="https://inter-nation.uz/banner.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://inter-nation.uz" />
        <meta property="og:site_name" content="inter-nation.uz" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Inter Nation English School Careers"
        />
        <meta
          name="twitter:description"
          content="Inter Nation English School is hiring! Discover open positions and start your career with us."
        />
        <meta
          name="twitter:image"
          content="https://inter-nation.uz/banner.png"
        />
      </Head>
      <HRPage />;
    </>
  );
};

export default HR;

export async function getStaticProps(context: any) {
  const { locale } = context;

  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}
